<template>
  <div class="chat-gpt">
    <div class="chat-gpt-left">
      <div class="item_btn" @click="createNewChat">新建聊天</div>
      <!-- 聊天列表 -->
      <div class="item_c_list">
        <div
          class="item_c"
          :class="{ active: activeIndex == index }"
          v-for="(chat, index) in chatList"
          :key="index"
          @click="selectChat(index)"
        >
          <p><i class="el-icon-chat-line-round"></i>{{ chat.title }}<i class="el-icon-delete" @click.stop="deleteChat(index)"></i></p>
        </div>
      </div>
    </div>
    <div class="chat-gpt-right" v-if="currentChat !== null">
      <div class="input-area-tit">
        我是一个基于DeepSeek智能技术的智能客服机器人，可以进行自然语言交互，提供智能问答、自动学习、智能推荐、自动聊天、智能语音识别等功能。
      </div>
      <div class="chat-area">
        <div
          v-for="(message, index) in currentChat.messages"
          :key="index"
          class="message"
        >
          <!-- 根据消息发送者动态添加样式 -->
          <div
            v-if="message.sender === 'machine'"
            class="message-bubble machine-response"
          >
            <div class="c_name">AI</div>
            <div class="c_cont">{{ message.text }}</div>
          </div>
          <div
            v-else-if="message.sender === 'me'"
            class="message-bubble user-message"
          >
            <div class="c_cont">{{ message.text }}</div>
            <div class="c_name">我</div>
          </div>
        </div>
        <div v-if="loading" style="overflow: hidden;height: 20px;">
          加载中...
        </div>
      </div>
      <div class="input-area">
        <el-input
          type="textarea"
          v-model="formData.inputMessage"
          placeholder="来说些什么吧"
          :disabled="isRobotReplying"
        ></el-input>
        <el-button
          type="primary"
          @click="sendMessage"
          :disabled="isRobotReplying"
          >发送</el-button
        >
      </div>
    </div>
    <div class="chat-gpt-right" v-else>
      <div>
        <p>请选择一个聊天</p>
      </div>
    </div>
  </div>
</template>
<script>
import { callDeepSeekAPI } from '@/api/deepseek' // 导入封装的 API 函数

export default {
  name: 'Chatbot',
  data () {
    return {
      loading: false,
      optimizedCode: false,
      formData: {
        inputMessage: ''
      },
      messages: [],
      chatList: [], // 存储聊天列表
      currentChat: null, // 存储当前选中的聊天
      activeIndex: null,
      isRobotReplying: false // 添加 isRobotReplying 属性
    }
  },
  mounted () {
    this.createNewChat()
  },
  methods: {
    // 创建新聊天
    createNewChat () {
      const newChat = {
        title: 'New Chat', // 聊天标题
        messages: [] // 聊天消息
      }
      this.chatList.push(newChat)
      this.formData.inputMessage = ''
      // 恢复发送按钮和输入数据
      this.isRobotReplying = false
      this.selectChat(this.chatList.length - 1) // 选择新创建的聊天
    },
    // 选择聊天
    selectChat (index) {
      this.currentChat = this.chatList[index]
      this.activeIndex = index
    },
    // 编辑聊天
    editChat () {
      // 处理编辑聊天的逻辑
      console.log(1)
    },
    // 删除聊天
    deleteChat (index) {
      this.chatList.splice(index, 1)
      if (this.chatList.length > 0) {
        this.selectChat(0) // 选择第一个聊天
        this.activeIndex = 0
      } else {
        this.currentChat = null // 如果没有聊天了，清空当前聊天
        this.activeIndex = null
      }
    },
    async sendMessage () {
      this.loading = true
      const userMessage = this.formData.inputMessage

      const currentChatNow = this.currentChat // 获取当前选中的聊天
      // 设置标题，您可以根据需要更改
      currentChatNow.title = userMessage

      // 禁用发送按钮和输入数据
      this.isRobotReplying = true

      // 用户消息
      const userMessageObj = { sender: 'me', text: '' }
      currentChatNow.messages.push(userMessageObj)

      try {
        const data = {
          // 替换为实际的请求参数
          messages: [
            {
              content: userMessage,
              role: 'user'
            }
          ],
          model: 'deepseek-chat',
          frequency_penalty: 0,
          max_tokens: 2048,
          presence_penalty: 0,
          response_format: {
            type: 'text'
          },
          stop: null,
          stream: false,
          stream_options: null,
          temperature: 1,
          top_p: 1,
          tools: null,
          tool_choice: 'none',
          logprobs: false,
          top_logprobs: null
        }
        const userMessageLetters = userMessage.split('') // 将用户消息拆分成字母数组

        for (const letter of userMessageLetters) {
          userMessageObj.text += letter
          // await this.delay(100) // 添加延迟以逐字显示
        }

        const deepseek = await callDeepSeekAPI(data)
        if (deepseek) {
          const answer = deepseek.choices[0].message.content
          // 机器回复
          const machineResponseObj = { sender: 'machine', text: '' }
          currentChatNow.messages.push(machineResponseObj)

          const answerLetters = answer.split('') // 将回复拆分成字母数组

          for (const letter of answerLetters) {
            machineResponseObj.text += letter
            // await this.delay(100) // 添加延迟以逐字显示
          }
        } else {
          console.error('API 调用失败:')
        }
      } catch (error) {
        console.error('API 调用失败:', error)
      } finally {
        this.loading = false
      }
      this.formData.inputMessage = ''
      // 恢复发送按钮和输入数据
      this.isRobotReplying = false
    },
    // 添加延迟函数
    delay (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    }
  }
}
</script>
<style>
.chat-gpt {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  font-size: 0.8333vw;

  /* 逐字显示动画 */
  .message-bubble {
    overflow: hidden;
  }

  .message-bubble[data-typing]::after {
    content: "";
    animation: typing 0.1s steps(1) infinite;
  }

  @keyframes typing {
    0% {
      width: 0;
    }
    100% {
      width: 100%;
    }
  }
  .machine-response {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .user-message {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
  }
  .chat-gpt-left {
    width: 20.8333vw;
    border: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1.0417vw 1.5625vw;
    min-width: 200px;

    .item_btn {
      width: 100%;
      margin: 0.5208vw 0;
      background-color: $color_1;
      color: #fff;
      height: 2.9167vw;
      border-radius: 0.4167vw;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .item_c_list {
      width: 100%;
      flex: 1;
      width: 100%;
      display: flex;
      flex-direction: column;

      .item_c {
        width: 100%;
        display: flex;
        align-items: center;
        border: 1px solid #ccc;
        height: 2.9167vw;
        justify-content: space-between;
        color: $color_1;
        border-radius: 0.3125vw;
        margin: 0 0 0.5208vw 0;
        cursor: pointer;
        p {
          display: flex;
          align-items: center;
          &:nth-child(1) {
            margin-top: 15px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }
        i {
          margin: 0 0.2604vw;
          font-size: 1.25vw;
          color: $color_1;
          cursor: pointer;
        }
        &.active {
          border: 1px solid $color_1;
          background: rgba($color: $color_1, $alpha: 0.1);
        }
      }
    }
  }
  .chat-gpt-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    padding: 0.5208vw;
    .input-area-tit {
      width: 100%;
      font-size: 1.0417vw;
      padding: 0 0 1.5625vw 0;
      color: #1d2f6c;
    }
    .chat-area {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      .message {
        .message-bubble {
          margin-bottom: 1.0417vw;
        }
        .c_name {
          width: 2.6042vw;
          height: 2.6042vw;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #18a058;
          border-radius: 50%;
          color: #fff;
          font-size: 0.8333vw;
          font-weight: 600;
          margin: 1.0417vw 0.5208vw 0 0.5208vw;
        }
        .c_cont {
          flex: 1;
          border-radius: 0.3125vw;
          background-color: #efefef;
          min-height: 4.1667vw;
          padding: 0.5208vw 1.0417vw;
          max-width: calc(100% - 15.625vw);
          display: flex;
          align-items: center;
        }
      }
    }
    .input-area {
      width: calc(100% - 1.0417vw);
      display: flex;
      align-items: flex-end;
      height: 8.3333vw;
      .el-textarea {
        width: 93% !important;
        height: 100% !important;
        display: flex;

        .el-textarea__inner {
          width: 100% !important;
          height: 100% !important;
        }
      }
      .el-button {
        margin: 0 0.5208vw;
      }
    }
  }
}
.vue-codemirror {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.CodeMirror {
  height: auto !important;
  flex: 1;
}
.CodeMirror-sizer {
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Chatbot.vue